// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionStatusPage_root__2zoDU","dialog":"AuctionStatusPage_dialog__1Z5_g","submitButton":"AuctionStatusPage_submitButton__1um9P"};